function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { SelectKind as s } from "./index.es135.js";
import e from "./index.es501.js";
var l = {
    styles: e.outlineKind,
    valuedStyles: e.outlineValued,
    errorStyles: e.outlineError,
    disabledStyles: e.outlineDisabled
  },
  t = {
    styles: e.ghostyKind,
    valuedStyles: "",
    errorStyles: e.ghostyError,
    disabledStyles: e.ghostyDisabled
  },
  o = {
    styles: e.simpleKind,
    valuedStyles: e.simpleValued,
    errorStyles: e.simpleError,
    disabledStyles: e.simpleDisabled
  },
  y = _defineProperty(_defineProperty(_defineProperty({}, s.outline, l), s.ghosty, t), s.simple, o),
  d = _defineProperty(_defineProperty(_defineProperty({}, s.outline, ""), s.ghosty, e.buttonGhosty), s.simple, "");
export { d as ColorSchemeButtonStylesMap, y as ColorSchemeStylesMap };